module.exports = __webpack_public_path__ + "img/LogoKarateDay2021.22d25258.png";